import React from 'react';
import { Route } from 'react-router';
import LoadingSwitch from 'lib/react-router/loading-switch';
import Inspirations from './inspirations';
import Inspiration from './inspiration/inspiration';
import RouteWithSearch from 'lib/react-router/route-with-search';

class InspirationsRouter extends React.PureComponent {
    render() {
        return (
            <LoadingSwitch>
                <RouteWithSearch path='/inspirations/:slug' exact={true} component={Inspiration} />
                <Route path='/inspirations' exact={true} component={Inspirations} />
            </LoadingSwitch>
        );
    }
}

export default InspirationsRouter;
